import type { ApiResponse } from '@/store/types'
import { remove } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UUID } from '@/backend/schema/uuid'

/**
 * Delete AI assisted review instruction on backend
 */
export const deleteInstruction = async (params: {
  team_slug: string
  id: UUID
}): Promise<ApiResponse<void> | ParsedError> => {
  const { team_slug, id } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions/${id}`

  try {
    const response = await remove<void>(path)
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_DELETE)
  }
}
